import { render, staticRenderFns } from "./goods-category.vue?vue&type=template&id=1d5a03db&scoped=true&"
import script from "./goods-category.vue?vue&type=script&lang=js&"
export * from "./goods-category.vue?vue&type=script&lang=js&"
import style0 from "./goods-category.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./goods-category.vue?vue&type=style&index=1&id=1d5a03db&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5a03db",
  null
  
)

export default component.exports